module.exports = __webpack_public_path__ + "static/media/product-testing-team-second.7f1c7828.jpg";